import React from 'react'
import PropTypes from 'prop-types'

import styles from '../FormByState.module.scss'
import { FormCheckbox } from 'components/form/checkbox/FormCheckbox'

export const MiFormConfig = {
  noUnprofessionalConduct: {},
  commentedOnUnprofessionalConduct: {},
}

export const MIForm = ({ formData, handleFieldChange }) => (
  <div className={styles.form}>
    <p>
      <u>EMPLOYER: NOTE TO CURRENT/PREVIOUS:</u> Public Act 189 of 1996 requires you to provide ESS copies of any and
      all information relating to unprofessional conduct contained within the above named person&apos;s personnel file
      within 20 days of the receipt of request. The Act provides that, &quot;an employer or an employee acting on behalf
      of the employer that discloses information under the section in good faith is immune from civil liability for the
      disclosure.&quot;
    </p>

    <p>
      <u>Please return copies of all such documents along with a signed copy of this request.</u> If no documentation of
      unprofessional conduct is contained within personnel file, please note it at the bottom of this form and return it
      to ESS. Maintain one copy for your records. Thank you for your assistance. If you have any questions or concerns,
      please contact the Employee Engagement Team at ESS (877) 855-7264.
    </p>
    <br />
    <div>
      <FormCheckbox
        title="I certify that no documentation of unprofessional conduct exists within the above-named personnel file."
        field={formData.noUnprofessionalConduct}
        onChange={value => handleFieldChange('noUnprofessionalConduct')(!!value)}
      />
    </div>
    <br />
    <div>
      <FormCheckbox
        title="I have commented on items relating to unprofessional conduct."
        field={formData.commentedOnUnprofessionalConduct}
        onChange={value => handleFieldChange(`commentedOnUnprofessionalConduct`)(!!value)}
      />
    </div>
  </div>
)

MIForm.propTypes = {
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
